// src/redux/api/operationsSelectors.ts

// Возвращает массив всех операций
import {RootState} from "../../store";
import {Operation} from "../../../types";

export const selectAllOperations = (state: RootState): Operation[] => {
    return Object.values(state.operations.operations);
};

// Возвращает операцию по ID
export const selectOperationById = (state: RootState, operationId: string): Operation | undefined => {
    return state.operations.operations[operationId];
};

// Возвращает только "активные" (InProgress) операции
export const selectActiveOperations = (state: RootState): Operation[] => {
    return Object.values(state.operations.operations).filter(op => op.status === 'InProgress');
};
